import { z } from "zod";

import { ActionSchema } from "../../shared/domain/agents";

/**
 * Tool default config — stored in AgentExternalTool.defaultConfig Json field.
 * Record of default ActionType values keyed by operationId.
 * Mirrors `agentExternalToolSchema.defaultConfig` in
 * shared/domain/tools/external-tool-config.ts.
 */
export const ToolDefaultConfigSchema = z.record(z.string(), ActionSchema).nullable();

export type ToolDefaultConfig = z.infer<typeof ToolDefaultConfigSchema>;
